<template>
  <iframe class="youtube-video" :src="'https://www.youtube-nocookie.com/embed/' + videoId + '?rel=0&modestbranding=1' + extraParams" frameborder="0" allowfullscreen></iframe>
</template>
<script>
export default {
  props: {
    videoId: String,
    start: Number,
    end: Number
  },
  computed: {
    extraParams: function() {
      var result = ''
      if (this.start) {
        result += '&start=' + start
      }
      if (this.end) {
        result += '&end=' + end
      }
      return result
    }
  }
}
</script>
<style lang="scss" scoped>
.youtube-video {
  width: 560px;
  height: 315px;
  max-width: 100%;
}
</style>
